__turbopack_context__.v({
  "buttons": "ApplyFlashMessage-module__eAObiq__buttons",
  "continueButton": "ApplyFlashMessage-module__eAObiq__continueButton",
  "fadeInItems": "ApplyFlashMessage-module__eAObiq__fadeInItems",
  "infoButton": "ApplyFlashMessage-module__eAObiq__infoButton",
  "overlay": "ApplyFlashMessage-module__eAObiq__overlay",
  "popup": "ApplyFlashMessage-module__eAObiq__popup",
  "spacing--lg": "ApplyFlashMessage-module__eAObiq__spacing--lg",
  "spacing--md": "ApplyFlashMessage-module__eAObiq__spacing--md",
  "spacing--sm": "ApplyFlashMessage-module__eAObiq__spacing--sm",
  "spacing--xl": "ApplyFlashMessage-module__eAObiq__spacing--xl",
  "spacing--xs": "ApplyFlashMessage-module__eAObiq__spacing--xs",
  "spacing--xxl": "ApplyFlashMessage-module__eAObiq__spacing--xxl",
  "spacing--xxs": "ApplyFlashMessage-module__eAObiq__spacing--xxs",
  "spacing--xxxl": "ApplyFlashMessage-module__eAObiq__spacing--xxxl",
  "spacing--xxxs": "ApplyFlashMessage-module__eAObiq__spacing--xxxs",
});
